import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarIngresosPss: ["payload"],
  consultarIngresosPssLoading: null,
  consultarIngresosPssSuccess: ["consultarIngresosPssData"],
  consultarIngresosPssFailure: ["consultarIngresosPssError"],

  limpiarIngresosPss: null,

  limpiarCoberturasCierreCuenta: null,

  eliminarCobertura: ["payload"],
  eliminarCoberturaLoading: null,
  eliminarCoberturaSuccess: ["eliminarCoberturaData"],
  eliminarCoberturaFailure: ["eliminarCoberturaError"],
  eliminarCoberturaDeIngresoDetalle: ["codigoCobertura"],
  limpiarEliminarCobertura: null,

  consultarCoberturasCierreCuenta: ["payload"],
  consultarCoberturasCierreCuentaLoading: null,
  consultarCoberturasCierreCuentaSuccess: [
    "consultarCoberturasCierreCuentaData",
  ],
  consultarCoberturasCierreCuentaFailure: [
    "consultarCoberturasCierreCuentaError",
  ],

  buscarCuentasCerradas: ["payload"],
  buscarCuentasCerradasLoading: null,
  buscarCuentasCerradasSuccess: ["buscarCuentasCerradasData"],
  buscarCuentasCerradasFailure: ["buscarCuentasCerradasError"],
  limpiarBuscarCuentasCerradas: null,

  validarCobertura: ["payload"],
  validarCoberturaLoading: null,
  validarCoberturaSuccess: ["validarCoberturaData"],
  validarCoberturaFailure: ["validarCoberturaError"],
  limpiarValidarCobertura: null,

  validarServicioAmbulatorio: ["payload"],
  validarServicioAmbulatorioLoading: null,
  validarServicioAmbulatorioSuccess: ["validarServicioAmbulatorioData"],
  validarServicioAmbulatorioFailure: ["validarServicioAmbulatorioError"],
  limpiarValidarServicioAmbulatorio: null,

  consultarTipoPssNoMedicoEgreso: ["payload"],
  consultarTipoPssNoMedicoEgresoLoading: null,
  consultarTipoPssNoMedicoEgresoSuccess: ["consultarTipoPssNoMedicoData"],
  consultarTipoPssNoMedicoEgresoFailure: ["consultarTipoPssNoMedicoError"],
  limpiarConsultarTipoPssNoMedico: null,

  validarAfiliadoVigente: ["payload"],
  validarAfiliadoVigenteLoading: null,
  validarAfiliadoVigenteSuccess: ["validarAfiliadoVigenteData"],
  validarAfiliadoVigenteFailure: ["validarAfiliadoVigenteError"],
  limpiarValidarAfiliadoVigente: null,

  guardarEgreso: ["payload"],
  guardarEgresoLoading: null,
  guardarEgresoSuccess: ["guardarEgresoData"],
  guardarEgresoFailure: ["guardarEgresoError"],
  limpiarGuardarEgreso: null,

  consultarReclamantes: ["payload"],
  consultarReclamantesLoading: null,
  consultarReclamantesSuccess: ["consultarReclamantesData"],
  consultarReclamantesFailure: ["consultarReclamantesError"],
  limpiarConsultarReclamantes: null,

  calcularOxigeno: ["payload"],
  calcularOxigenoLoading: null,
  calcularOxigenoSuccess: ["calcularOxigenoData"],
  calcularOxigenoFailure: ["calcularOxigenoError"],
  limpiarCalcularOxigeno: null,

  insertarCobertura: ["payload"],
  insertarCoberturaLoading: null,
  insertarCoberturaSuccess: ["insertarCoberturaData"],
  insertarCoberturaFailure: ["insertarCoberturaError"],
  limpiarInsertarCobertura: null,

  cerrarCuentaClinica: ["payload"],
  cerrarCuentaClinicaLoading: null,
  cerrarCuentaClinicaSuccess: ["cerrarCuentaClinicaData"],
  cerrarCuentaClinicaFailure: ["cerrarCuentaClinicaError"],
  limpiarCerrarCuentaClinica: null,

  validarIngresoExistente: ["payload"],
  validarIngresoExistenteLoading: null,
  validarIngresoExistenteSuccess: ["validarIngresoExistenteData"],
  validarIngresoExistenteFailure: ["validarIngresoExistenteError"],
  limpiarValidarIngresoExistente: null,

  enviarReclamacion: ["payload"],
  enviarReclamacionLoading: null,
  enviarReclamacionSuccess: ["enviarReclamacionData"],
  enviarReclamacionFailure: ["enviarReclamacionError"],
  limpiarEnviarReclamacion: null,

  formConsultaCierresCuentas: ["payload"],
  formConsultaCierresCuentasLoading: null,
  formConsultaCierresCuentasSuccess: ["formConsultaCierresCuentasData"],

  consultarCierresCuentas: ["payload"],
  consultarCierresCuentasLoading: null,

  consultarPlanesEgreso: ["payload"],
  consultarPlanesEgresoLoading: null,
  consultarPlanesEgresoSuccess: ["consultarPlanesEgresoData"],
  consultarPlanesEgresoFailure: ["consultarPlanesEgresoError"],

  cambiarServicio: ["payload"],
  cambiarServicioLoading: null,
  cambiarServicioSuccess: ["cambiarServicioData"],
  cambiarServicioFailure: ["cambiarServicioError"],
  limpiarCambiarServicio: null,

  consultarEstatusHojaQuirurgica: ["payload"],
  consultarEstatusHojaQuirurgicaLoading: null,
  consultarEstatusHojaQuirurgicaSuccess: ["consultarEstatusHojaQuirurgicaData"],
  consultarEstatusHojaQuirurgicaFailure: ["consultarEstatusHojaQuirurgicaError"],
  limpiarConsultarEstatusHojaQuirurgica: null,

  consultaIngresoDetalleCoberturaHojaQx: ["payload"],
  consultaIngresoDetalleCoberturaHojaQxLoading: null,
  consultaIngresoDetalleCoberturaHojaQxSuccess: ["consultaIngresoDetalleCoberturaHojaQxData"],
  consultaIngresoDetalleCoberturaHojaQxFailure: ["consultaIngresoDetalleCoberturaHojaQxError"],
  limpiarConsultaIngresoDetalleCoberturaHojaQx: null,

  consultarDiasHospitalarios: null,
  consultarDiasHospitalariosLoading: null,
  consultarDiasHospitalariosSuccess: ["consultarDiasHospitalariosData"],
  consultarDiasHospitalariosFailure: ["consultarDiasHospitalariosError"],
  limpiarConsultarDiasHospitalarios: null,
});

export { Types };
export default Creators;
